/** The parts of a DOMRect that decide whether a control is really on screen. */
export interface TargetRect {
  width: number;
  height: number;
}

/**
 * Whether a resolved anchor is worth spotlighting (KEY-535).
 *
 * `document.querySelector` finds elements that are not being rendered: a control hidden with
 * `display: none` is still in the DOM, still matches, and still answers `getBoundingClientRect()` — with
 * zeros. The overlay would then draw a 12px spotlight box in the top-left corner of the page with its
 * coach-mark card beside it, pointing at nothing.
 *
 * That is not hypothetical. The header's Help button used to carry `kd-hide-sm`, which is `display: none
 * !important` below 560px, so on a phone the tour's "here's where Help lives" step did exactly this. That
 * particular case is now fixed at source — the button collapses to its icon rather than vanishing — but the
 * hazard is the general one, and `kd-hide-sm` is still in use elsewhere in the chrome.
 *
 * Treating a zero-area target as not-yet-found is the fix: the step keeps polling (so the control can still
 * arrive) and shows its `hint` instead of a spotlight on the corner of the screen.
 */
export function isUsableTarget(rect: TargetRect | null | undefined): boolean {
  return !!rect && rect.width > 0 && rect.height > 0;
}
